import useUser from 'utils/useUser';
import { hasCombinedModuleAccess } from 'infrastructure/functions';
import { RoleGroups } from 'infrastructure/consts';
import { useBlockedSession } from 'infrastructure/providers/blocked-session-context';

import type { UserType } from 'infrastructure/enums';

export const useCheckRoleAccess = () => {
  const { roleNames, userType } = useUser();
  const isBlocked = useBlockedSession();

  const isReadOnlyRole =
    isBlocked ||
    !hasCombinedModuleAccess(
      roleNames,
      RoleGroups.ReadOnlyDenyRolesMap,
      userType as UserType,
    );

  return {
    isReadOnlyRole,
  };
};
